import { _ as _defineProperty } from '../../defineProperty-1e8516b1.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import * as React from 'react';
import { useTheme, css } from '@emotion/react';
import { motion } from 'framer-motion';
import { Wrapper } from './Checkbox.styles.js';
import { Hyphen } from './Hyphen.js';
import { getThemeColors } from './util/util.js';
import '@emotion/styled/base';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    indeterminate = _ref.indeterminate,
    onClick = _ref.onClick,
    _ref$themeColors = _ref.themeColors,
    themeColors = _ref$themeColors === void 0 ? true : _ref$themeColors,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? size / 5 : _ref$borderRadius,
    _ref$outerSize = _ref.outerSize,
    outerSize = _ref$outerSize === void 0 ? size * 2.5 : _ref$outerSize,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? size / 6 : _ref$strokeWidth,
    _ref$innerPadding = _ref.innerPadding,
    innerPadding = _ref$innerPadding === void 0 ? size / 6 : _ref$innerPadding,
    _ref$outerBackgroundC = _ref.outerBackgroundColor,
    outerBackgroundColor = _ref$outerBackgroundC === void 0 ? 'transparent' : _ref$outerBackgroundC,
    _ref$outerBackgroundC2 = _ref.outerBackgroundColorHover,
    outerBackgroundColorHover = _ref$outerBackgroundC2 === void 0 ? 'rgba(120, 120, 120, 0.075)' : _ref$outerBackgroundC2,
    _ref$checkmarkColor = _ref.checkmarkColor,
    checkmarkColor = _ref$checkmarkColor === void 0 ? '#7F56D9' : _ref$checkmarkColor,
    _ref$checkmarkBackgro = _ref.checkmarkBackground,
    checkmarkBackground = _ref$checkmarkBackgro === void 0 ? 'white' : _ref$checkmarkBackgro,
    _ref$checkmarkBackgro2 = _ref.checkmarkBackgroundChecked,
    checkmarkBackgroundChecked = _ref$checkmarkBackgro2 === void 0 ? '#F9F5FF' : _ref$checkmarkBackgro2,
    _ref$hyphenColor = _ref.hyphenColor,
    hyphenColor = _ref$hyphenColor === void 0 ? checkmarkColor : _ref$hyphenColor,
    _ref$hyphenBackground = _ref.hyphenBackgroundColor,
    hyphenBackgroundColor = _ref$hyphenBackground === void 0 ? '#F9F5FF' : _ref$hyphenBackground,
    _ref$hyphenBorderColo = _ref.hyphenBorderColor,
    hyphenBorderColor = _ref$hyphenBorderColo === void 0 ? checkmarkColor : _ref$hyphenBorderColo,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? '#d9d9d9' : _ref$borderColor,
    _ref$borderColorHover = _ref.borderColorHover,
    borderColorHover = _ref$borderColorHover === void 0 ? checkmarkColor : _ref$borderColorHover,
    _ref$borderColorCheck = _ref.borderColorChecked,
    borderColorChecked = _ref$borderColorCheck === void 0 ? checkmarkColor : _ref$borderColorCheck,
    forwardedRef = _ref.forwardedRef;
  var theme = useTheme();
  var colors = React.useMemo(function () {
    return themeColors ? getThemeColors(theme) : {};
  }, [theme, themeColors]);
  var className = "checkbox__input".concat(indeterminate ? ' indeterminate' : '');
  var handleClick = React.useCallback(function (e) {
    if (forwardedRef == null) {
      e.preventDefault();
      if (onClick) {
        onClick(e, !checked);
      }
    } else {
      if (!onClick) return;
      var current = forwardedRef.current;
      onClick(e, !!(current !== null && current !== void 0 && current.checked));
    }
  }, [forwardedRef, onClick, checked]);
  return jsx(Wrapper, _objectSpread(_objectSpread({
    className: "checkbox__outer-wrapper",
    size: outerSize,
    innerPadding: innerPadding,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    outerBackgroundColor: outerBackgroundColor,
    outerBackgroundColorHover: outerBackgroundColorHover,
    checkmarkColor: checkmarkColor,
    checkmarkBackground: checkmarkBackground,
    checkmarkBackgroundChecked: checkmarkBackgroundChecked,
    borderColor: borderColor,
    borderColorHover: borderColorHover,
    borderColorChecked: borderColorChecked,
    hyphenBackgroundColor: hyphenBackgroundColor,
    hyphenBorderColor: hyphenBorderColor,
    onClick: handleClick
  }, colors), {}, {
    children: jsxs(motion.div, {
      className: "checkbox__inner-wrapper",
      css: /*#__PURE__*/css({
        position: 'relative',
        width: size,
        height: size
      }, process.env.NODE_ENV === "production" ? "" : ";label:css;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [jsx("input", _objectSpread({
        type: "checkbox",
        className: className
      }, forwardedRef ? {
        ref: forwardedRef
      } : {
        readOnly: true,
        tabIndex: -1,
        checked: !!checked
      }), "checkbox"), !!indeterminate && jsx(Hyphen, {
        color: (colors === null || colors === void 0 ? void 0 : colors.hyphenColor) || hyphenColor,
        strokeWidth: strokeWidth,
        padding: innerPadding,
        borderRadius: borderRadius / 2
      })]
    })
  }));
};
var CheckboxForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return jsx(Checkbox, _objectSpread(_objectSpread({}, props), {}, {
    forwardedRef: ref
  }));
});
var CheckboxControlled = function CheckboxControlled(props) {
  return jsx(Checkbox, _objectSpread({}, props));
};
export { CheckboxControlled, CheckboxForwardRef };